import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import { useNotifications } from "../../components/NotificationContext/NotificationContext";
import "./Header.css";

const Header = ({
  onLogout,
  userData,
  pageType,
  toggleSidebar,
  sidebarOpen,
  onViewPermissions,
  isLoggingOut = false,
}) => {
  const navigate = useNavigate();
  const {
    notifications,
    markAsRead,
    markAllAsRead,
    getUserNotifications,
    getUnreadCount,
    readNotifications,
  } = useNotifications();
  const [showNotifications, setShowNotifications] = useState(false);
  const [userNotifications, setUserNotifications] = useState([]);

  // Kullanıcı bildirimlerini güncelle
  useEffect(() => {
    if (userData) {
      const userNotifs = getUserNotifications(userData);
      console.log("Kullanıcı bildirimleri:", userNotifs); // Debug için
      setUserNotifications(userNotifs);
    } else {
      setUserNotifications([]);
    }
  }, [notifications, userData, getUserNotifications]);

  // Okunmamış bildirim sayısını hesapla
  const unreadCount = userData ? getUnreadCount(userData) : 0;

  const handleNotificationClick = (notification) => {
    if (userData) {
      markAsRead(notification.id, userData.user_id);
    }
    setShowNotifications(false);
    if (notification.route) {
      navigate(notification.route);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isLoggingOut) return;
    try {
      if (onLogout && typeof onLogout === "function") {
        await onLogout();
      }
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Header - Çıkış hatası:", error);
      navigate("/login", { replace: true });
    }
  };

  const getPageTitle = () => {
    switch (pageType) {
      case "admin":
        return "Yönetim Paneli";
      case "employee":
        return "Çalışan Paneli";
      case "maintenance":
        return "Bakım Paneli";
      default:
        return "RFID Sistemi";
    }
  };

  const getUserEmail = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        return user.email || "kullanici@email.com";
      } catch (error) {
        console.error("Kullanıcı bilgileri parse edilirken hata:", error);
        return "kullanici@email.com";
      }
    }
    return "kullanici@email.com";
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return "Şimdi";
    if (diffMins < 60) return `${diffMins} dakika önce`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} saat önce`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} gün önce`;
  };

  // Bildirimin okunup okunmadığını kontrol et
  const isNotificationRead = (notificationId) => {
    if (!userData) return false;
    // readNotifications[userData.user_id] bir dizi değilse boş dizi kullan
    const readIds = Array.isArray(readNotifications[userData.user_id])
      ? readNotifications[userData.user_id]
      : [];
    return readIds.includes(notificationId);
  };

  return (
    <header
      className={`header ${pageType}-header ${
        sidebarOpen ? "sidebar-open" : ""
      }`}
    >
      <div className="header-left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i>
        </button>
        {!sidebarOpen && <h1>{getPageTitle()}</h1>}
      </div>
      <div className="header-right">
        <div className="header-notifications">
          <button
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <i className="fas fa-bell"></i>
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>
          {showNotifications && (
            <div className="notification-dropdown">
              <div className="notification-header">
                <h3>Bildirimler</h3>
                <button onClick={() => setShowNotifications(false)}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="notification-list">
                {userNotifications.length > 0 ? (
                  userNotifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={`notification-item ${
                        !isNotificationRead(notification.id) ? "unread" : ""
                      }`}
                      onClick={() => handleNotificationClick(notification)}
                    >
                      <div className={`notification-icon ${notification.type}`}>
                        <i
                          className={`fas ${notification.icon || "fa-bell"}`}
                        ></i>
                      </div>
                      <div className="notification-content">
                        <div className="notification-title">
                          {notification.title}
                        </div>
                        <div className="notification-message">
                          {notification.message}
                        </div>
                        <div className="notification-time">
                          {formatTime(notification.timestamp)}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-notifications">
                    <i className="fas fa-bell-slash"></i>
                    <p>Bildirim bulunmuyor</p>
                  </div>
                )}
              </div>
              {userNotifications.length > 0 && (
                <div className="notification-footer">
                  <button
                    onClick={() => userData && markAllAsRead(userData.user_id)}
                  >
                    Tümünü Okundu İşaretle
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="user-info">
          <span>{getUserEmail() || "Kullanıcı"}</span>
          <button
            className="logout-btn"
            onClick={handleLogout}
            type="button"
            disabled={isLoggingOut}
          >
            {isLoggingOut ? (
              <OrbitLoaderComponent size="small" showPath={false} />
            ) : (
              <>
                <i className="fas fa-sign-out-alt"></i>
                <span className="logout-text">Çıkış</span>
              </>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
